var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlayOutline = function SvgPlayOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"play outline\""
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 132",
    cx: 10,
    cy: 10,
    r: 9.625,
    transform: "matrix(-1 0 0 1 20.791 0)",
    stroke: "#283333",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.72913 6.2921C8.53569 6.17435 8.29102 6.31757 8.29102 6.54855V13.4514C8.29102 13.6824 8.53569 13.8257 8.72913 13.7079L14.3988 10.2565C14.5884 10.141 14.5884 9.859 14.3988 9.74354L8.72913 6.2921Z",
    fill: "#283333"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayOutline);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IiYjMjQwOyYjMTU5OyYjMTY2OyYjMTM0OyBpY29uICYjMzQ7cGxheSBvdXRsaW5lJiMzNDsiPgo8Y2lyY2xlIGlkPSJFbGxpcHNlIDEzMiIgY3g9IjEwIiBjeT0iMTAiIHI9IjkuNjI1IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyMC43OTEgMCkiIHN0cm9rZT0iIzI4MzMzMyIgc3Ryb2tlLXdpZHRoPSIwLjc1Ii8+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik04LjcyOTEzIDYuMjkyMUM4LjUzNTY5IDYuMTc0MzUgOC4yOTEwMiA2LjMxNzU3IDguMjkxMDIgNi41NDg1NVYxMy40NTE0QzguMjkxMDIgMTMuNjgyNCA4LjUzNTY5IDEzLjgyNTcgOC43MjkxMyAxMy43MDc5TDE0LjM5ODggMTAuMjU2NUMxNC41ODg0IDEwLjE0MSAxNC41ODg0IDkuODU5IDE0LjM5ODggOS43NDM1NEw4LjcyOTEzIDYuMjkyMVoiIGZpbGw9IiMyODMzMzMiLz4KPC9nPgo8L3N2Zz4K";